import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { WorkflowRequestInterceptorService } from './workflow-request-interceptor.service';
//import { FEATURE_HTTP_INTERCEPTORS, RemoteHttpClient } from 'core/interceptor/remote-http-client.service';
//import { AuthenticationInterceptorService } from '../../services/authentication-interceptor.service';
@NgModule({
	imports: [
		CommonModule,
	],
	declarations: [],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: WorkflowRequestInterceptorService,
			multi: true,
		},
		// {
		// 	provide: FEATURE_HTTP_INTERCEPTORS,
		// 	useClass: WorkflowRequestInterceptorService,
		// 	multi: false
		// },
		// RemoteHttpClient
	]
})
export class WorkflowRequestInterceptorModule { }